module.exports = __webpack_public_path__ + "img/about-img-two.95e74084.jpg";